import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-repair-details',
  templateUrl: './repair-details.component.html',
  styleUrls: ['./repair-details.component.css', '../order.component.css'],
})
export class RepairDetailsComponent {
  @Input() orderForm: FormGroup;
  @Output() saveOrder = new EventEmitter<{ destination: string }>();

  onSave(destination: string): void {
    this.saveOrder.emit({ destination });
  }

  onPost(): void {
    this.onSave('POST');
  }
}
